<template>
  <div id="Tab1">
    <div class="tab-content student-tabs-content">
      <div class="row">
        <div class="col-8 h-100">
          <TitleBreadcrumb :page="page" />
        </div>

        <div class="col-4 text-right">
          <ActionButton
            class="outline-success mr-3"
            i="fas fa-arrow-circle-left"
            type="button"
          >
            Regresar
          </ActionButton>

          <ActionButton class="success" i="fas fa-save" type="button">
            Guardar
          </ActionButton>
        </div>
      </div>

      <!-- Separator -->
      <div class="col-12 dropdown-divider pb-4 w-100" />

      <div>
        <SectionTitle
          :has-line="true"
          content="Documentación de Controversia en PEI"
        />

        <div class="col-12">
          <div class="row w-100">
            <div class="col-12">
              <span>
                Partes del PEI que están en controversia
                <span style="font-weight: initial;">
                  (se puede marcar más de una opción)
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 pl-3 text-left">
        <WizardQuestion
          v-for="item in questionList"
          id="qQuestions"
          :ref="'id_' + item.id"
          :key="item.id"
          :description="item.title"
          :fields="item.fields"
          :has-icon="false"
          :answer-control-type="0"
          error-message="mensaje"
          default-option-value-selected="1"
          :get-options="getDropdownOptions"
          :display-number="item.displayNumber"
          no-border
          dropdown-upper-text="Manera en que se resolvió la controversia"
        />
      </div>

      <div class="mt-5">
        <SectionTitle
          :has-line="true"
          content="Documentos del PEI en Controversia"
        />

        <div class="col-12 no-padding">
          <div class="header thead-property d-flex align-items-center">
            <div class="row w-100">
              <div class="col-2 pl-4 ml-4 pt-0 ">
                <span>Fecha</span>
              </div>
              <div class="col-md-7 pl-3">
                <div class="d-flex align-space-between">
                  <div class="col-4 pl-0 pt-0">
                    <span>Tipo</span>
                  </div>
                  <div class="col-3 pl-0 pt-0">
                    <span>Título</span>
                  </div>
                  <div class="col-3 pl-0 pt-0">
                    <span>Comentario</span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <span />
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 pt-0 no-padding">
          <div class="content d-flex align-items-center">
            <div class="row w-100 regular">
              <div class="col-2 pl-4 ml-4 pt-2 ">
                <span>31/ene/2020</span>
              </div>
              <div class="col-md-7 pl-3 ">
                <div class="d-flex align-space-between">
                  <div class="col-4 pl-0 pt-2">
                    <span>Minuta - Controversia</span>
                  </div>
                  <div class="col-3 pl-0 pt-2">
                    <span>Documento del PEI</span>
                  </div>
                  <div class="col-6 pl-0 pt-2">
                    <span>Comentario sobre el documento del PEI.</span>
                  </div>
                  <div class="col-4 pl-0 pt-0">
                    <button
                      type="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-toggle="dropdown"
                      class="one-px-border btn btn-success-outline btn-tabHeader-outline dropdown-toggle float-right"
                    >
                      Acciones
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <a
                        v-for="menuItem in actions"
                        :key="menuItem.text"
                        class="dropdown-item cursor-pointer"
                        href="javascript:void(0)"
                        :class="
                          ishiddenForAttachmentTypeCode(menuItem, item)
                            ? 'hidden'
                            : ''
                        "
                        v-bind="menuItem.dataAttributes"
                        @click="handle_function_call(menuItem.method, item)"
                      >
                        <em :class="menuItem.iconClass" />
                        {{ menuItem.text }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />

        <div>
          <div v-if="!isAddMode" class="text-center">
            <BoxIconButton
              :icon="'fas fa-file-plus'"
              :title="'Presione aquí para anejar documento'"
              class="w-49 margin-auto"
              @click="onAddClickHandler"
            />
          </div>
        </div>

        <div v-if="isAddMode" class="col-12">
          <CustomCollapse id="addControversyDocument">
            <CustomCollapseItem
              id="subAreasSelectionItem"
              parent-id="addControversyDocument"
              title="Añadir Documento"
              expanded
              selected
            >
              <div class="row">
                <div class="col-md-2">
                  <CustomDatePicker label="Fecha:" />
                </div>
                <div class="col-md-4">
                  <CustomDropDown
                    label="Tipo:"
                    placeholder="Seleccion"
                    fieldkey="id"
                    fieldname="title"
                  />
                </div>
                <div class="col-md-6">
                  <BoxIconButton
                    title="Presione aquí para anejar documento"
                    icon="fas fa-file-plus"
                    label="Documento:"
                    class="box-icon-button-custom"
                  />
                </div>
              </div>
              <div class="row mt-4">
                <div class="col">
                  <CustomTextArea
                    :rows="4"
                    label="Añadir Comentario:"
                    :maxlength="500"
                  />
                </div>
              </div>
              <div class="row text-right">
                <div class="col-12">
                  <ActionButton id="save" class="px-4" variant="success">
                    Añadir
                  </ActionButton>
                </div>
              </div>
            </CustomCollapseItem>
          </CustomCollapse>
        </div>

        <hr />

        <div class="container-fluid container-foot d-flex justify-content-end ">
          <ActionButton
            id="save"
            variant="success"
            i="fas fa-save"
            @click="save"
          >
            Guardar
          </ActionButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CustomDatePicker,
  ActionButton,
  CustomDropDown,
  CustomTextArea,
} from '@/components/common';
import { SectionTitle } from '@/components/pei/shared';
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import WizardQuestion from '@/components/pei/WizardQuestion';
import BoxIconButton from '@/components/pei/shared/BoxIconButton';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';

export default {
  components: {
    SectionTitle,
    TitleBreadcrumb,
    ActionButton,
    WizardQuestion,
    BoxIconButton,
    CustomCollapse,
    CustomCollapseItem,
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
  },
  methods: {
    onAddClickHandler() {
      this.isAddMode = true;
    },
    ishiddenForAttachmentTypeCode(menuItem, item) {
      let results =
        menuItem.hidden !== undefined &&
        menuItem.hidden.filter((AttachmentTypeCode) => {
          return AttachmentTypeCode === item.attachmentTypeCode;
        }).length > 0;
      return results;
    },
    getDropdownOptions() {
      let dropdownOptions = [{ value: 1, option: 'Seleccionar' }];
      return this.resolveOptions(dropdownOptions);
    },
    resolveOptions(options) {
      let promise = new Promise(async (resolve) => {
        let optionsResponse = [];
        options.forEach((element) => {
          optionsResponse.push({
            Value: element.value ? element.value : element.option,
            Display: element.option,
            isSelected: element.selected,
          });
        });
        resolve(optionsResponse);
      });
      return promise;
    },
  },
  data() {
    return {
      documentTypeList: [{ id: 1, title: 'PEI Document' }],
      peiHistoryData: [
        {
          academicYear: '2019-2020',
          peiComment: 'Comentario',
          peiTypeDesc: 'Tipo Descripción',
          peiIdFormatted: '2020130171',
          generalRevisionNo: 1,
          peiStatusDescription: 'Borrador',
          generalClosedDate: null,
          generalClosedDateFormat: '01/01/0001',
          peiStatusColor: '#C05046',
          peiStatusId: 1,
          peiControversyFlag: false,
          peiReferralFlag: true,
        },
      ],
      tableConfig: {
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 10,
        },
        columns: [
          {
            label: 'Fecha',
            field: 'academicYear',
          },
          {
            label: 'Tipo',
            field: 'peiTypeDesc',
          },
          {
            label: 'Título',
            field: 'peiIdFormatted',
          },
          {
            label: 'Comentario',
            field: 'peiComment',
          },
        ],
      },
      isAddMode: false,
      disabledAll: false,
      IsDraft: false,
      page: {
        icon: 'fas fa-user-edit',
        title: 'PEI: Controversia',
        routes: ['Inicio', 'PEI', 'Controversia'],
      },
      actions: [
        {
          iconClass: 'fas text-green fa-file-alt mr-1',
          method: 'downloadFile',
          text: 'Descargar',
        },
        {
          iconClass: 'fas text-green fa-pencil-alt mr-1',
          method: 'editFile',
          text: 'Editar',
        },
        {
          iconClass: 'fas text-red fa-times-circle mr-1',
          method: 'showConfirmationDelete',
          text: 'Eliminar',
          dataAttributes: {
            'data-toggle': 'modal',
            'data-target': '#popup',
          },
        },
      ],
      tabTitle: 'PEI: Controversia',
      questionList: [
        {
          id: 1,
          number: 1,
          title:
            '<b>Firmas de los miembros del Comité de Programación y Ubicación</b><br><b>Comentario:</b><br>Comentario ingresado anteriormente aparecerá aquí.<br>',
          answer: true,
          comment: '',
          parentQuestion: null,
          displayNumber: 'XIII.',
        },
        {
          id: 2,
          number: 2,
          title:
            '<b>Firmas de los miembros del Comité de Programación y Ubicación</b><br><b>Comentario:</b><br>Comentario ingresado anteriormente aparecerá aquí.<br>',
          answer: true,
          comment: '',
          parentQuestion: null,
          displayNumber: 'XIII.',
        },
        {
          id: 3,
          number: 3,
          title:
            '<b>Firmas de los miembros del Comité de Programación y Ubicación</b><br><b>Comentario:</b><br>Comentario ingresado anteriormente aparecerá aquí.<br>',
          answer: true,
          comment: '',
          parentQuestion: null,
          displayNumber: 'XIII.',
        },
        {
          id: 4,
          number: 4,
          title:
            '<b>Firmas de los miembros del Comité de Programación y Ubicación</b><br><b>Comentario:</b><br>Comentario ingresado anteriormente aparecerá aquí.<br>',
          answer: true,
          comment: '',
          parentQuestion: null,
          displayNumber: 'XIII.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.btn-success-outline {
  height: 42px;
  border: 1px solid #2db782 !important;
  color: black;
  font-weight: 400;
}
.header {
  height: 54px;
  padding-left: 20px;
  background: #3f5b60 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.content {
  height: 74px;
  padding-left: 20px;
  color: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  border-bottom: 1px solid #d9e5df;
}
.thead-property {
  color: #ffffff;
}
.no-padding {
  padding-left: 0;
  padding-right: 0;
}
.margin-auto {
  margin: auto;
}
.one-px-border {
  border: 1px solid;
}
.height-auto {
  height: auto;
}
.line-height-2em {
  line-height: 2em;
}
</style>
